/* hp-modal-carousel.js — turns the product zoom modal into a single-image carousel.
   Self-contained; no edits to global.js. Progressive enhancement over Dawn's product-modal. */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 50;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Prevent Dawn's ModalDialog backdrop-close from firing when interacting with our controls.
  // ModalDialog closes on pointer/mouse events that bubble to <product-modal>, so we swallow them.
  function shield(el) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'touchstart', 'touchend', 'click'].forEach(function (ev) {
      el.addEventListener(ev, function (e) { e.stopPropagation(); }, false);
    });
  }

  function initModal(modal) {
    if (!modal || modal.__hpCarousel) return;
    modal.__hpCarousel = true;

    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var mediaSelector = '[data-media-id]';
    function getMedia() {
      return Array.prototype.slice.call(content.querySelectorAll(mediaSelector));
    }

    var media = getMedia();
    if (!media.length) return;

    var index = 0;
    var touchStartX = null;
    var listenersActive = false;

    // ---- Build controls ----
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hp-modal-nav hp-modal-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" style="pointer-events:none"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M15 5l-7 7 7 7"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hp-modal-nav hp-modal-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" style="pointer-events:none"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>';

    var counter = document.createElement('div');
    counter.className = 'hp-modal-counter';
    counter.setAttribute('aria-live', 'polite');

    modal.appendChild(prev);
    modal.appendChild(next);
    modal.appendChild(counter);

    shield(prev);
    shield(next);
    shield(counter);

    function eagerLoad(el) {
      if (!el) return;
      if (el.tagName === 'IMG') {
        el.loading = 'eager';
        if (el.dataset && el.dataset.src && !el.src) el.src = el.dataset.src;
        if (el.src && typeof el.decode === 'function') { el.decode().catch(function () {}); }
      } else {
        var innerImg = el.querySelector && el.querySelector('img');
        if (innerImg) eagerLoad(innerImg);
      }
    }

    function setActive(i) {
      media = getMedia();
      if (!media.length) return;
      var n = media.length;
      index = ((i % n) + n) % n; // wrap-around
      for (var k = 0; k < n; k++) {
        if (k === index) media[k].classList.add('is-active');
        else media[k].classList.remove('is-active');
      }
      eagerLoad(media[index]);
      counter.textContent = (index + 1) + ' / ' + n;
      var single = n <= 1;
      prev.style.display = single ? 'none' : '';
      next.style.display = single ? 'none' : '';
    }

    function goPrev() { setActive(index - 1); }
    function goNext() { setActive(index + 1); }

    function onKey(e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
    }

    function onTouchStart(e) {
      if (e.changedTouches && e.changedTouches.length) touchStartX = e.changedTouches[0].clientX;
    }
    function onTouchEnd(e) {
      if (touchStartX === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) >= SWIPE_THRESHOLD) { if (dx < 0) goNext(); else goPrev(); }
      touchStartX = null;
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goPrev(); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goNext(); });

    function activateListeners() {
      if (listenersActive) return;
      listenersActive = true;
      document.addEventListener('keydown', onKey);
      content.addEventListener('touchstart', onTouchStart, { passive: true });
      content.addEventListener('touchend', onTouchEnd, { passive: true });
    }
    function deactivateListeners() {
      if (!listenersActive) return;
      listenersActive = false;
      document.removeEventListener('keydown', onKey);
      content.removeEventListener('touchstart', onTouchStart);
      content.removeEventListener('touchend', onTouchEnd);
    }

    // ---- Determine which image was clicked to open the modal ----
    var pendingMediaId = null;
    var toggles = document.querySelectorAll('.product__media-toggle[data-media-id], .product__modal-opener [data-media-id]');
    Array.prototype.forEach.call(toggles, function (t) {
      t.addEventListener('click', function () { pendingMediaId = t.getAttribute('data-media-id'); }, true);
    });

    function indexForMediaId(id) {
      if (!id) return -1;
      var list = getMedia();
      for (var k = 0; k < list.length; k++) {
        var mid = list[k].getAttribute('data-media-id') || '';
        if (mid === id || mid.indexOf(id) !== -1 || id.indexOf(mid) !== -1) return k;
      }
      return -1;
    }

    function onOpen() {
      var idx = indexForMediaId(pendingMediaId);
      if (idx < 0) {
        var current = content.querySelector('.is-active[data-media-id]');
        if (current) idx = getMedia().indexOf(current);
      }
      if (idx < 0) idx = 0;
      setActive(idx);
      activateListeners();
      modal.scrollTop = 0;
      pendingMediaId = null;
    }

    function onClose() { deactivateListeners(); }

    var wasOpen = modal.hasAttribute('open');
    var mo = new MutationObserver(function () {
      var isOpen = modal.hasAttribute('open');
      if (isOpen && !wasOpen) onOpen();
      else if (!isOpen && wasOpen) onClose();
      wasOpen = isOpen;
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['open'] });

    setActive(0);
    if (modal.hasAttribute('open')) onOpen();
  }

  ready(function () {
    var modals = document.querySelectorAll('product-modal.media-modal');
    Array.prototype.forEach.call(modals, initModal);
  });
})();
